import { gql } from "@apollo/client";

export const BULK_ADD_LABELS = gql`
  mutation BulkAddLabelsToAdObject($id: ID!, $labels: [JSONObject!]!) {
    bulkAddLabelsToAdObject(id: $id, labels: $labels, manual: true) {
      id
      labelsDigest {
        key
        value
        isManualLabel
        canDelete
        resolutionOrder
      }
    }
  }
`;

export const REMOVE_ALL_LABELS = gql`
  mutation RemoveAllLabels($id: ID!) {
    removeAllLabelsFromAdObject(id: $id, manual: true) {
      id
      labelsDigest {
        key
        value
        isManualLabel
        canDelete
        resolutionOrder
      }
    }
  }
`;
